/**
 * 红线规则配置编辑器分发：targeting_type → 对应富编辑器组件；未知类型兜底
 * GenericConfigEditor（双 textarea + JSON 校验）。
 */
import type { ComponentType } from "react";
import type { EditorProps } from "./types";
import { LegalDateEditor } from "./LegalDateEditor";
import { LaunchTimeEditor } from "./LaunchTimeEditor";
import { IdListEditor } from "./IdListEditor";
import { BidlimitEditor } from "./BidlimitEditor";
import { ExcludedCustomEditor } from "./ExcludedCustomEditor";
import { SpecialConditionEditor } from "./SpecialConditionEditor";
import { GenericConfigEditor } from "./GenericConfigEditor";

export const REDLINE_EDITOR_MAP: Record<string, ComponentType<EditorProps>> = {
  legal_date: LegalDateEditor,
  launch_time_series: LaunchTimeEditor,
  launch_url: IdListEditor,
  bidlimit_apply: BidlimitEditor,
  bidlimit_reservation: BidlimitEditor,
  bidlimit_click: BidlimitEditor,
  excluded_custom: ExcludedCustomEditor,
  special_condition: SpecialConditionEditor,
};

/** 取 targeting_type 对应的编辑器；未知类型返回 GenericConfigEditor。 */
export function getRedlineEditor(targeting_type: string): ComponentType<EditorProps> {
  return REDLINE_EDITOR_MAP[targeting_type] ?? GenericConfigEditor;
}
